import Main from './private/Main'
import OrderWords from './private/OrderWords'
import QuizQuestions from './private/QuizQuestions'
import WordSearch from './private/WordSearches'
import LogIn from './LogIn'


export const ProtectedRoutes = { Main, OrderWords, QuizQuestions, WordSearch }

export const PublicRoutes = { LogIn };